import {
  enableProdMode,
  provideZoneChangeDetection,
  APP_INITIALIZER,
  importProvidersFrom,
} from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { initializeApp } from "./app/app.module";
import { environment } from "./environments/environment";
import {
  DxDataGridComponent,
  DxCheckBoxModule,
  DxSwitchModule,
  DxPopoverModule,
  DxPopupModule,
  DxScrollViewModule,
  DxTemplateModule,
  DxTabPanelModule,
  DxFormModule,
  DxRangeSliderModule,
  DxNumberBoxModule,
  DxRadioGroupModule,
  DxLoadPanelModule,
  DxAccordionModule,
  DxSpeedDialActionModule,
  DxSelectBoxModule,
  DxGalleryModule,
  DxDataGridModule,
  DxButtonModule,
  DxTreeListModule,
  DxHtmlEditorModule,
  DxAutocompleteModule,
  DxToolbarModule,
} from "devextreme-angular";
import { providePrimeNG } from "primeng/config";
import {
  FilterService,
  ConfirmationService,
  MessageService,
} from "primeng/api";
import { ConfigService } from "./app/config.service";
import { firstValueFrom } from "rxjs";
import { DialogService, DynamicDialogModule } from "primeng/dynamicdialog";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { AuthInterceptor } from "./app/AuthInterceptor";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { ChartModule } from "primeng/chart";
import { CarouselModule } from "primeng/carousel";
import { TabsModule } from "primeng/tabs";
import { ToastModule } from "primeng/toast";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToggleSwitchModule } from "primeng/toggleswitch";
import { TableModule } from "primeng/table";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { InputMaskModule } from "primeng/inputmask";
import { SkeletonModule } from "primeng/skeleton";
import { BadgeModule } from "primeng/badge";
import { RadioButtonModule } from "primeng/radiobutton";
import { ProgressBarModule } from "primeng/progressbar";
import { TooltipModule } from "primeng/tooltip";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PanelModule } from "primeng/panel";
import { NgSelectModule } from "@ng-select/ng-select";
import { AccordionModule } from "primeng/accordion";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { OrganizationChartModule } from "primeng/organizationchart";
import { ColorPickerModule } from "ngx-color-picker";
import { AutoCompleteModule } from "primeng/autocomplete";
import { DatePickerModule } from "primeng/datepicker";
import { SelectModule } from "primeng/select";
import { MultiSelectModule } from "primeng/multiselect";
import { DialogModule } from "primeng/dialog";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { DrawerModule } from "primeng/drawer";
import { CheckboxModule } from "primeng/checkbox";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { provideRouter } from "@angular/router";
import { routes } from "./app/app.routes";
import { AppComponent } from "./app/app.component";
import Aura from "@primeng/themes/aura";

export function getBaseUrl() {
  return document.getElementsByTagName("base")[0].href;
}

const providers = [{ provide: "BASE_URL", useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      NgxSliderModule,
      ChartModule,
      CarouselModule,
      TabsModule,
      ToastModule,
      ScrollPanelModule,
      DxCheckBoxModule,
      DxSwitchModule,
      ConfirmDialogModule,
      DxPopoverModule,
      DxPopupModule,
      DxScrollViewModule,
      DxTemplateModule,
      DxTabPanelModule,
      ToggleSwitchModule,
      TableModule,
      DxFormModule,
      ScrollingModule,
      InputMaskModule,
      DynamicDialogModule,
      SkeletonModule,
      BadgeModule,
      RadioButtonModule,
      ProgressBarModule,
      DxRangeSliderModule,
      DxNumberBoxModule,
      DxRadioGroupModule,
      DxLoadPanelModule,
      DxAccordionModule,
      DxSpeedDialActionModule,
      DxSelectBoxModule,
      TooltipModule,
      FormsModule,
      // NgxUsefulSwiperModule,
      PanelModule,
      DxGalleryModule,
      DxDataGridModule,
      DxButtonModule,
      DxTreeListModule,
      DxHtmlEditorModule,
      DxAutocompleteModule,
      DxToolbarModule,
      NgSelectModule,
      // OrgchartModule,
      AccordionModule,
      NgbModule,
      OrganizationChartModule,
      ColorPickerModule,
      AutoCompleteModule,
      DatePickerModule,
      SelectModule,
      MultiSelectModule,
      DialogModule,
      ReactiveFormsModule,
      BsDatepickerModule,
      NgIdleKeepaliveModule.forRoot(),
      DrawerModule,
      CheckboxModule,
      InputTextModule,
      ButtonModule,
    ),
    DxDataGridComponent,
    providePrimeNG({
      theme: { preset: Aura, options: { darkModeSelector: false } },
    }),
    FilterService,
    ConfirmationService,
    MessageService,
    ConfigService,
    DialogService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
  ],
}).catch((err) => console.log(err));

// export { renderModuleFactory } from '@angular/platform-server';
